// removed by extract-text-webpack-plugin
module.exports = {"forgotPassword-container":"index__forgotPassword-container___2GXh2","forgotPassword-actions-container":"index__forgotPassword-actions-container___1uSTv","forgotPassword-form-wrapper":"index__forgotPassword-form-wrapper___vn9g4","forgotPassword-form-label":"index__forgotPassword-form-label___3qeoP","forgotPassword-form-reset-password-label":"index__forgotPassword-form-reset-password-label___1rqxy","forgotPassword-form-input":"index__forgotPassword-form-input___38WSj","signInBtn":"index__signInBtn___2QEnR"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Auth/ForgotPassword/index.less
// module id = 679
// module chunks = 3